<template>
  <div class="card card-custom card-stretch gutter-b">
    <b-overlay :show="loading" variant="white" rounded="sm">
    

    <div class="card-body pt-3 pb-0">
      <div class="table-responsive">

        <div v-show="items.length == 0 && !loading" class="alert alert-custom alert-notice alert-light-warning fade show mb-5 mt-5" role="alert">
            <div class="alert-icon">
              <i class="flaticon-warning"></i>
            </div>
            <div class="alert-text"><strong>Búsqueda sin resultados</strong>. Intente nuevamente buscando con otros parámetros.</div>
            <div class="alert-close">
              
            </div>
        </div>
        
        <table class="table table-head-custom table-vertical-center" v-show="items.length > 0 && !loading">
          <thead>
            <tr class="text-left">
              <th class="pr-0" style="width: 50px">Rut</th>
              <th style="min-width: 200px">Nombres</th>
              <th style="min-width: 150px">Apellidos</th>
              <th style="min-width: 150px">Email</th>
              <th style="min-width: 150px">Telefono</th>
              <th style="min-width: 200px">Rol</th>
              <th style="min-width: 200px">FechaCreacion</th>
              <th style="min-width: 200px">FechaActualizacion</th>
              <th style="min-width: 200px">Activo</th>              
              <th class="pr-0" style="min-width: 100px">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in items" v-bind:key="i">
              <td class="pl-0 py-4">
                <div class="symbol symbol-50 symbol-light mr-1" :class="item.Etapa">
                  <span class="symbol-label">
                    <inline-svg
                      src="media/svg/avatars/006-girl-3.svg" 
                      class="h-50 align-self-center"
                    />
                  </span>
                </div>
              </td>
              <td class="pl-0 py-4">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.rutUsuatio }} - {{ item.rutUsuatioDv }}
                </span>
              </td>
               <td class="pl-0 py-4">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.nombres }}
                </span>
              </td>
               <td class="pl-0 py-4">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.apellidos }}
                </span>
              </td>
               <td class="pl-0 py-4">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.email }}
                </span>
              </td>
               <td class="pl-0 py-4">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.telefono }}
                </span>
              </td>
              <td class="pl-0">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.codigoRol }}
                </span>
              </td>
              <td class="pl-0">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.fechaCreacion }}
                </span>
              </td>
              <td class="pl-0">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.fechaActualizacion }}
                </span>
              </td>
              <td class="pl-0">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  {{ item.activo }}
                </span>
              </td>

            


            </tr>
          </tbody>
        </table>

        <v-pagination v-model="page" :length="pages" v-if="pages > 1" :total-visible="10" min="1"
            step="1" ></v-pagination>

      </div>
    </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "dataTableWidget",
  props: {
    headers: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    loading: { type: Boolean, required: true },
    itemKey: String,
    customClickAction: Function,
    pagination: {
      type: Object,
      required: true
    },
    pages : { type :Number, required : true }
  },
  watch:{
    page: {
      handler () {
        //console.log(("dataTableWidget  handler: page: "+ this.page + " ,page size: " + this.pagination.page_size);
        this.$emit('fetch-more', { page: this.page, page_size: this.pagination.page_size, filter : "" })
      },
      deep: true
    }
  },
  computed: {
    // pages () {
    //   //console.log(("registros: " + this.pagination.totalRecords + " , paginas " + this.page_size)
    //     return Math.ceil(this.pagination.totalRecords / this.page_size);
    // }
  },
  data() {
    return {
      page: 1,
      page_size: this.pagination.page_size, 
    }
  },
  mounted() {
      
  },
  methods: {
    getPercent(item){
      return Math.round((item.TotalArchivosCargados / item.TotalArchivos)*100);
    },
    getVariantType(item) {
      let porcentaje = this.getPercent(item);
      if (porcentaje == 100) {
          return 'success'
      } else if (porcentaje >= 50) {
          return 'warning'
      } else if (porcentaje > 30) {
          return 'primary'
      }
      return 'danger'
    }
  }
}
</script>